const CHUNK_ERROR_PATTERNS = [
  /loading chunk/i,
  /failed to fetch dynamically imported module/i,
  /cannot find module/i,
]

const SESSION_KEY = 'chunk-reload-attempted'
const RELOAD_COOLDOWN_MS = 10_000

export function isChunkLoadError(error: unknown): boolean {
  if (error instanceof Error) {
    if (error.name === 'ChunkLoadError') {
      return true
    }
    return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(error.message))
  }
  return false
}

export function handleChunkLoadError(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    const lastReload = sessionStorage.getItem(SESSION_KEY)
    if (lastReload) {
      const elapsed = Date.now() - Number(lastReload)
      if (elapsed < RELOAD_COOLDOWN_MS) {
        sessionStorage.removeItem(SESSION_KEY)
        return false
      }
    }
    sessionStorage.setItem(SESSION_KEY, Date.now().toString())
    window.location.reload()
    return true
  } catch {
    return false
  }
}
